export default __webpack_public_path__ + "static/media/SWT1680.34I-39093_-23028_0.e9cfdbcd.jpg";